import { BaseService } from "./base";
import { IHttpClientResponse, HttpClient } from "app/core/http";
import { ILoginRequest, IHttpClientData, ILoginResponse } from "../types";

export class AuthService extends BaseService {
    constructor(httpClient: HttpClient) {
        super(httpClient);
        this.login = this.login.bind(this);
    }

    public async login(params: ILoginRequest): Promise<IHttpClientResponse<IHttpClientData<ILoginResponse>>> {
        return this.httpClient.post("/api/user/signin", params);
    }
}
